// Types related to Users

export enum UserStatus {
  ACTIVATED = "ACTIVATED",
  INACTIVATED = "INACTIVATED",
  RECONFIGURE = "RECONFIGURE",
  BLOCKED = "BLOCKED",
  ONBOARDING_IN_PROGRESS = "ONBOARDING_IN_PROGRESS",
  TICKET_OPENING = "TICKET_OPENING"
}

export interface UserDto {
  id?: string;
  username?: string;
  email?: string;
  status?: UserStatus;
  properties?: Record<string, any>; // Campo genérico para propriedades diversas
  application_id?: string;
  sso_reference_id?: string; // Adicionado
  first_name?: string;
  last_name?: string;
  phone_number?: string;
  language_code?: string;
  created_at?: string;
  updated_at?: string;
}

// Interface genérica para respostas paginadas
export interface PaginatedResponseDto<T> {
  content: T[];
  current_page: number;
  page_size: number;
  total_elements: number;
}

// Resposta paginada específica para usuários
export type ListUserDto = PaginatedResponseDto<UserDto>;

export interface ChatContent {
  content?: string;
  sources?: ChatSource[];
  toolExecutions?: ChatToolExecution[];
}

export interface ChatSource {
  type?: string;
  mimeType?: string;
}

export interface ChatToolExecution {
  chatToolRequest?: ChatToolRequest;
  result?: string;
}

export interface ChatToolRequest {
  id?: string;
  name?: string;
  arguments?: string;
}

export interface UserChatMessageDto {
  id?: string;
  type?: string;  // SYSTEM, USER, AI, ASSISTANT, TOOL_EXECUTION_RESULT
  content?: string | ChatContent;
  sources?: ChatSource[];
  sequence_id?: number;
  correlation_id?: string;
  user_id?: string;
  tool_executions?: ChatToolExecution[];
  provider_name?: string;
  model_name?: string;
  finish_reason?: string;
  input_tokens?: number;
  output_tokens?: number;
  total_tokens?: number;
  created_at?: string;
}

// Interface para o formato atual
export interface ListUserChatMessageDto {
  data: UserChatMessageDto[];
  current_page: number;
  total_pages?: number;
  total_items?: number;
}

// Interface para o formato da API conforme Swagger
export interface PaginatedResponseUserChatMessageDto {
  content: UserChatMessageDto[];
  current_page: number;
  page_size: number;
  total_elements: number;
}

// Alias para compatibilidade com código existente (para não quebrar)
export type PaginatedChatMessageResponseDto = PaginatedResponseUserChatMessageDto;

export interface ScheduleActionParametersDto {
  name: string;
  description: string;
}

export interface ReminderDto {
  interval: "MINUTES" | "HOURS" | "DAYS" | "WEEKS" | "MONTHS" | "YEARS";
  value: number;
  active?: boolean;
  name: string;
  description?: string;
  reminder_types: Array<"BOT" | "EMAIL" | "SMS">;
}

export interface ScheduleActionDto {
  id?: string;
  timezone: "AMERICA_SAO_PAULO" | "UTC";
  parameters: ScheduleActionParametersDto;
  reminders?: ReminderDto[];
  user_id?: string;
  action_type: "CUSTOM_TASK";
  scheduled_type: "ONCE" | "RECURRING";
  starts_in: string;
  ends_in: string;
  recurring_until?: string;
  repetition_type?: "DAILY" | "WEEKLY" | "MONTHLY" | "YEARLY";
  next_execution?: string;
  notified_at?: string;
  cancelled_at?: string;
}

export interface PaginatedResponseScheduleActionDto {
  content: ScheduleActionDto[];
  current_page: number;
  page_size: number;
  total_elements: number;
}

export interface HealthDeviceAuthRequestDto {
  provider: "FREESTYLELIBRE" | "GARMIN" | "APPLE";
  auth_success_redirect_url: string;
  auth_failure_redirect_url: string;
  use_terra_avengers_app?: boolean;
}

export interface HealthDeviceAuthResponseDto {
  provider?: "FREESTYLELIBRE" | "GARMIN" | "APPLE";
  authorization_url?: string;
}

export interface HealthDeviceResponseDto {
  id?: string;
  user?: any; // Full User object would be here
  provider?: "FREESTYLELIBRE" | "GARMIN" | "APPLE";
  language?: string;
  enabled?: boolean;
  parameters?: Record<string, string>;
  createdAt?: string;
  updatedAt?: string;
}